import React from "react";
import {CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import {money, formatDate} from "../format.js";
import {PnlTooltip} from "./PnlTooltip.jsx";

export function PnlCurve({dailyPnl, animate = true}) {
    return (
        <div className="chart-frame">
            <ResponsiveContainer width="100%" height="100%">
                <LineChart data={dailyPnl} margin={{top: 8, right: 12, left: 8, bottom: 0}}>
                    <CartesianGrid strokeDasharray="2 4" stroke="#1e293b"/>
                    <XAxis dataKey="date" tickFormatter={(value) => formatDate(String(value))} minTickGap={24}/>
                    <YAxis tickFormatter={(value) => money(Number(value))}/>
                    <Tooltip content={<PnlTooltip/>}/>
                    <Line
                        type="monotone" dataKey="cumulativePnl" name="Cumulative PnL"
                        stroke="#38bdf8" strokeWidth={2} dot={false}
                        activeDot={{r: 4}} isAnimationActive={animate}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}
